import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, NavigationEnd } from '@angular/router';
import { Router } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState, loadedMenusState, loginStateisAuthenticated } from 'src/app/store/reducers';

import { MenuDTO } from 'src/app/models/Menu/MenuDTO';

@Injectable()
export class AuthGuard implements CanActivate, OnDestroy {
  constructor(private router: Router, private store: Store<AppState>) {
    this.isAuthenticated$ = this.store.pipe(select(loginStateisAuthenticated));
    this.isAuthenticatedSubs = this.isAuthenticated$.subscribe((isAuthenticated: boolean) => {
      this.isAuthenticated = isAuthenticated;
    });
  }

  isAuthenticatedSubs: Subscription;
  isAuthenticated$: Observable<boolean>;
  isAuthenticated: boolean | false;

  menusListSubs: Subscription;
  menusList$: Observable<MenuDTO[]>;
  menusList: MenuDTO[];
  menuExists = false;

  currentPath: string;

  routerEventsSub: Subscription;

  canActivate() {
    this.routerEventsSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const { url } = event;
        this.currentPath = this.getCurrentPath(url);
        this.validateMenu();
        this.routerEventsSub.unsubscribe();
      }     
    });
   
    // check if the sessionToken is valid
    if (localStorage.getItem('isAuthenticated') === 'true') {
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }

  getCurrentPath(url: string) {
    let currentPath = url.substring(1);
    const index = currentPath.match('/')?.index;
    if (index) {
      currentPath = currentPath.substring(0, index)
    }
    return currentPath;
  }

  validateMenu() {
    this.menusList$ = this.store.pipe(select(loadedMenusState));
    this.menusListSubs = this.menusList$.subscribe((menu: MenuDTO[]) => {
      if (menu) {
        this.menusList = menu;
        this.validateRoute(this.menusList, this.currentPath);
        if (!this.menuExists) {
          setTimeout(() => {
            this.router.navigate(["/not-found"]);
          }, 0);
        }
      }
    });
  }

  validateRoute(menusList: MenuDTO[], currentPath: string) {
    if (menusList && currentPath) {
      menusList.forEach((menuEl) => {
        this.subMenusIterator(menuEl);
      });
    }
  }

  subMenusIterator(menuElement: MenuDTO) {
    const { code, subMenus } = menuElement;
    if (code && code === "folder") {
      for (const subMenuEl of subMenus) {
        this.subMenusIterator(subMenuEl);
      }
    } else {
      this.checkRoutesArray(menuElement);
    }
  }

  checkRoutesArray(menuElement: MenuDTO) {
    const foundedRoute = this.router.config.find((config) => config?.data?.code === menuElement.code);
    if (this.currentPath === foundedRoute?.path) {
      this.menuExists = true;
    }
  }

  ngOnDestroy(): void {
    this.isAuthenticatedSubs.unsubscribe();
  }
}
